require('./openYoungPersonalDataForm.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { connect } = require('react-redux');
const { sortByOrder } = require('lodash/collection');
const moment = require('moment');

// @ helpers
const { FormattedText, formatText } = require('core/i18n').i18n;
const PersonalDataHelper = require('utilities/personalDataHelper');

// @ commons
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { InputSafe } = require('commonsComponents/inputSafe');
const { RadioButton } = require('commonsComponents/radioButton');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const OKSelect = require('components/commons/OKSelect/OKSelect');

// @ actions
const openYoungPersonalDataActions = require('actions/openYoungPersonalData');

// @ constants
const { countryOptions } = require('constants/countries');
const provincesOptions = require('constants/provinces');
const sortedProvincesOptions = sortByOrder(
    Object.keys(provincesOptions).map(key => ({
        value: key,
        label: provincesOptions[key]
    })
    ),
    ['label'],
    ['asc']
);
const {
    DATE_PICKER_CUSTOM_PLACEHOLDER,
    DATE_PICKER_CUSTOM_LOCALE,
    DATE_PICKER_CUSTOM_DATE_FORMAT
} = require('constants/commonsComponents');
const {
    DEFAULT_COUNTRY,
    DOCUMENT_TYPE_NIE,
    DOCUMENT_TYPE_NIF,
} = require('constants/index');

class OpenYoungPersonalDataForm extends React.Component {

    constructor(props) {
        super(props);

        this.handleChangeValidatePopulation = this.handleChangeValidatePopulation.bind(this);
    }

    handleChangeValidatePopulation(event) {
        const {
            setField,
        } = this.props;
        const {
            name,
            value,
        } = event.target;

        if (PersonalDataHelper.isValidRoadNameInput(value)) {
            setField(name, value);
        }
    }

    render() {
        const {
            readOnly,
            immOpenYoungPersonalData,
            setField,
            validateDocument,
            validateField,
            isOYPack,
            isCountryOfBirthInValid,
        } = this.props;
        const messageLessThanMinDateError = (
            <FormattedText
                className="open-young-personal-data-form__date-picker-error"
                value="openYoungPersonalDataForm-openYoungPersonalDataForm_messageLessThanMinDateError"
            />
        );
        const messageMoreThanMinDateError = (
            <FormattedText
                className="open-young-personal-data-form__date-picker-error"
                value="openYoungPersonalDataForm-openYoungPersonalDataForm_messageMoreThanMinDateError"
            />
        );
        const mandatoryFieldErrorMsg = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_mandatoryFieldError');
        const nameLabel = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_name');
        const nameErrorState = immOpenYoungPersonalData.getIn(['name', 'isDirty']) && !immOpenYoungPersonalData.getIn(['name', 'isValid']);
        const lastNameLabel = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_lastName1');
        const lastNameErrorState = immOpenYoungPersonalData.getIn(['lastName', 'isDirty']) && !immOpenYoungPersonalData.getIn(['lastName', 'isValid']);
        const lastName2Label = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_lastName2');
        const lastName2ErrorState = immOpenYoungPersonalData.getIn(['lastName2', 'isDirty']) && !immOpenYoungPersonalData.getIn(['lastName2', 'isValid']);
        const documentTypeLabel = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_documentType');
        const documentNumberLabel = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_documentNumber');
        const isOyCardHired = immOpenYoungPersonalData.getIn(['documentNumber', 'isOyCardHired']);
        const isOyAccountHired = immOpenYoungPersonalData.getIn(['documentNumber', 'isOyAccountHired']);
        let documentNumberErrorMessage = mandatoryFieldErrorMsg;

        if (isOYPack) {
            if (isOyCardHired) {
                documentNumberErrorMessage = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_existingOYCardDocumentNumberError');
            } else if (isOyAccountHired) {
                documentNumberErrorMessage = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_documentNumberDuplicatedError');
            }
        } else if (isOyCardHired) {
            documentNumberErrorMessage = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_existingOYCardDocumentNumberError');
        }

        const documentNumberErrorState =
            immOpenYoungPersonalData.getIn(['documentNumber', 'isDirty']) &&
            !immOpenYoungPersonalData.getIn(['documentNumber', 'isValid']) &&
            !immOpenYoungPersonalData.getIn(['documentNumber', 'isFetching']);
        const documentDisabled = readOnly || immOpenYoungPersonalData.getIn(['documentNumber', 'isFetching']);
        const birthDateLabel = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_birthdate');
        const birthCountryLabel = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_birthCountry');
        const birthPopulationLabel = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_birthPopulation');
        const birthPopulationErrorState = immOpenYoungPersonalData.getIn(['population', 'isDirty']) && !immOpenYoungPersonalData.getIn(['population', 'isValid']);
        const birthProvinceLabel = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_birthProvince');
        const birthProvinceErrorState = immOpenYoungPersonalData.getIn(['province', 'isDirty']) && !immOpenYoungPersonalData.getIn(['province', 'isValid']);
        const genderLabel = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_gender');
        const genderMaleLabel = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_genderMale');
        const genderFemaleLabel = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_genderFemale');
        const combosPlaceholder = formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_combosPlaceholder');
        const documentTypeOptions = [
            {
                value: DOCUMENT_TYPE_NIF,
                label: formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_NIF')
            },
            {
                value: DOCUMENT_TYPE_NIE,
                label: formatText('openYoungPersonalDataForm-openYoungPersonalDataForm_NIE')
            }
        ];
        let provinceSelect;
        if (immOpenYoungPersonalData.getIn(['country', 'value']) === DEFAULT_COUNTRY) {
            provinceSelect = (
                <div className="col-xs-4 open-young-personal-data-form__input-grid-section">
                    <OKSelect
                        disabled={readOnly && isCountryOfBirthInValid}
                        errorMessage={mandatoryFieldErrorMsg}
                        errorState={birthProvinceErrorState}
                        label={birthProvinceLabel}
                        onChange={(event) => setField('province', event.value)}
                        options={sortedProvincesOptions}
                        placeholder={combosPlaceholder}
                        searchable={true}
                        value={immOpenYoungPersonalData.getIn(['province', 'value'])}
                    />
                </div>
            );
        }

        return (
            <article className="open-young-personal-data-form">
                <FormattedText
                    className="open-young-personal-data-form__subtitle"
                    value="openYoungPersonalDataForm-openYoungPersonalDataForm_subitle"
                />
                <div className="row">
                    <div className="col-xs-4 open-young-personal-data-form__input-grid-section">
                        <InputSafe
                            disabled={readOnly}
                            errorMessage={mandatoryFieldErrorMsg}
                            errorState={nameErrorState}
                            label={nameLabel}
                            maxLength="20"
                            name="name"
                            onBlur={(event) => validateField(event.target.name)}
                            onChange={(event) => setField(event.target.name, event.target.value)}
                            type="text"
                            value={immOpenYoungPersonalData.getIn(['name', 'value'])}
                        />
                    </div>
                    <div className="col-xs-4 open-young-personal-data-form__input-grid-section">
                        <InputSafe
                            disabled={readOnly}
                            errorMessage={mandatoryFieldErrorMsg}
                            errorState={lastNameErrorState}
                            label={lastNameLabel}
                            maxLength="80"
                            name="lastName"
                            onBlur={(event) => validateField(event.target.name)}
                            onChange={(event) => setField(event.target.name, event.target.value)}
                            type="text"
                            value={immOpenYoungPersonalData.getIn(['lastName', 'value'])}
                        />
                    </div>
                    <div className="col-xs-4 open-young-personal-data-form__input-grid-section">
                        <InputSafe
                            disabled={readOnly}
                            errorMessage={mandatoryFieldErrorMsg}
                            errorState={lastName2ErrorState}
                            label={lastName2Label}
                            maxLength="80"
                            name="lastName2"
                            onBlur={(event) => validateField(event.target.name)}
                            onChange={(event) => setField(event.target.name, event.target.value)}
                            type="text"
                            value={immOpenYoungPersonalData.getIn(['lastName2', 'value'])}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-4 open-young-personal-data-form__input-grid-section">
                        <OKSelect
                            disabled={readOnly}
                            label={documentTypeLabel}
                            onChange={(event) => setField('documentType', event.value)}
                            options={documentTypeOptions}
                            placeholder={combosPlaceholder}
                            searchable={false}
                            value={immOpenYoungPersonalData.getIn(['documentType', 'value'])}
                        />
                    </div>
                    <div className="col-xs-4 open-young-personal-data-form__input-grid-section">
                        <InputSafe
                            disabled={documentDisabled}
                            customClass="text-uppercase"
                            errorMessage={documentNumberErrorMessage}
                            errorState={documentNumberErrorState}
                            label={documentNumberLabel}
                            maxLength="80"
                            name="documentNumber"
                            onBlur={(event) => validateField(event.target.name, validateDocument, isOYPack, event.target.value)}
                            onChange={(event) => setField(event.target.name, event.target.value)}
                            type="text"
                            value={immOpenYoungPersonalData.getIn(['documentNumber', 'value'])}
                        />
                    </div>
                    <div className="col-xs-4 open-young-personal-data-form__input-grid-section">
                        <DatePickerCustom
                            disabled={readOnly}
                            callback={(value) => setField('birthDate', value)}
                            callbackError={(value) => setField('birthDate', value)}
                            dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                            messageLessThanMinDateError={messageLessThanMinDateError}
                            messageMoreThanMinDateError={messageMoreThanMinDateError}
                            newSelectedDate={immOpenYoungPersonalData.getIn(['birthDate', 'value'])}
                            label={birthDateLabel}
                            locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                            maxDate={moment()}
                            minDate={moment().startOf('day').subtract(18, 'years').add(1, 'days')}
                            placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                            selectedDate={immOpenYoungPersonalData.getIn(['birthDate', 'value'])}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-4 open-young-personal-data-form__input-grid-section">
                        <OKSelect
                            disabled={readOnly && isCountryOfBirthInValid}
                            label={birthCountryLabel}
                            onChange={(event) => setField('country', event.value)}
                            options={countryOptions()}
                            placeholder={combosPlaceholder}
                            searchable={true}
                            value={immOpenYoungPersonalData.getIn(['country', 'value'])}
                        />
                    </div>
                    <div className="col-xs-4 open-young-personal-data-form__input-grid-section">
                        <InputSafe
                            disabled={readOnly}
                            errorMessage={mandatoryFieldErrorMsg}
                            errorState={birthPopulationErrorState}
                            label={birthPopulationLabel}
                            maxLength="50"
                            name="population"
                            onBlur={(event) => validateField(event.target.name)}
                            onChange={this.handleChangeValidatePopulation}
                            type="text"
                            value={immOpenYoungPersonalData.getIn(['population', 'value'])}
                        />
                    </div>
                    {provinceSelect}
                </div>
                <div className="row">
                    <div className="col-xs-4 open-young-personal-data-form__input-grid-section">
                        <RadioButtonGroup
                            idPrefix="gender"
                            key="gender"
                            label={genderLabel}
                            name="gender"
                            onChange={(value) => setField('gender', value)}
                            selectedValue={immOpenYoungPersonalData.getIn(['gender', 'value'])}
                            value={immOpenYoungPersonalData.getIn(['gender', 'value'])}
                        >
                            <RadioButton
                                disabled={readOnly}
                                key="openYoungPersonalDataForm-openYoungPersonalDataForm_genderMale"
                                label={genderMaleLabel}
                                value="0"
                            />
                            <RadioButton
                                disabled={readOnly}
                                key="openYoungPersonalDataForm-openYoungPersonalDataForm_genderFemale"
                                label={genderFemaleLabel}
                                value="1"
                            />
                        </RadioButtonGroup>
                    </div>
                    <div className="col-xs-4 open-young-personal-data-form__input-grid-section">
                        <OKSelect
                            disabled={readOnly}
                            label="openYoungPersonalDataForm-openYoungPersonalDataForm_nationality"
                            onChange={(event) => setField('nationality', event.value)}
                            options={countryOptions()}
                            placeholder="openYoungPersonalDataForm-openYoungPersonalDataForm_combosPlaceholder"
                            searchable={true}
                            value={immOpenYoungPersonalData.getIn(['nationality', 'value'])}
                        />
                    </div>
                </div>
            </article>
        );
    }
}

OpenYoungPersonalDataForm.propTypes = {
    immOpenYoungPersonalData: PropTypes.object.isRequired,
    isCountryOfBirthInValid: PropTypes.bool,
    isOYPack: PropTypes.bool,
    readOnly: PropTypes.bool,
    reset: PropTypes.func.isRequired,
    setField: PropTypes.func.isRequired,
    validateDocument: PropTypes.bool,
    validateField: PropTypes.func.isRequired,
};

OpenYoungPersonalDataForm.defaultProps = {
    isOYPack: false,
    readOnly: false,
    validateDocument: false,
    isCountryOfBirthInValid: false,
};

module.exports.constructor = OpenYoungPersonalDataForm;

module.exports.OpenYoungPersonalDataForm = connect(null,
    {
        reset: openYoungPersonalDataActions.reset,
        setField: openYoungPersonalDataActions.setField,
        validateField: openYoungPersonalDataActions.validateField,
    }
)(OpenYoungPersonalDataForm);
